export const FLAG_GETTING_SHIFTS = 'FLAG_GETTING_SHIFTS';
export const SHOW_ERROR_GETTING_SHIFTS = 'SHOW_ERROR_GETTING_SHIFTS';
export const CLEAR_ERROR_GETTING_SHIFTS = 'CLEAR_ERROR_GETTING_SHIFTS';
export const GET_SHIFTS = 'GET_SHIFTS';
export const CLEAR_SHIFTS = 'CLEAR_SHIFTS';
